import * as React from 'react';
import { Redirect, Route, RouteProps } from 'react-router';
import { checkPermission } from '../../Utilities/appHelpers';

type Permission = { Id?: string; PermissionCode: string; PermissionName: string };

export interface IAuthRoute extends RouteProps {
   permission: Permission | Permission[];
   all?: boolean;
}

const AuthRoute: React.FC<IAuthRoute> = (props) => {
   const { permission, all, ...rest } = props;
   const allowed = checkPermission(permission, all);

   if (!allowed) {
      return <Redirect to="/dashboard" />;
   }

   return <Route {...rest} />;
};

export default AuthRoute;
